import React, { Component } from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import PropTypes from 'prop-types';

Pagination.propTypes = {
  children: PropTypes.array,
  className: PropTypes.string,
  listClassName: PropTypes.string,
  cssModule: PropTypes.object,
  size: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  listTag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  'aria-label': PropTypes.string
};


export default class PaginationGenerator extends Component {
  render() {
    let stateStatus, nextPage, typeAndOrder, initialPages = [], activeStyle = {padding: "8px 16px" , background: '#ADD8E6' , color: '#003366'};
    let buttonStyle = {padding: "8px 16px"};
    let extraFilters = false;
    stateStatus = this.props.stateStatus;
    nextPage = this.props.nextPage;
    typeAndOrder = this.props.typeAndOrder;
    extraFilters = this.props.extraFilters.ready;

    if (stateStatus.totalPages > 1 && stateStatus.totalPages < 6) {
      for (let i = 0; i !== stateStatus.totalPages; i++) {
        initialPages.push(
          <PaginationItem key={i + 121}>
            <PaginationLink style={ Number(stateStatus.currentPage) === i + 1 ? activeStyle : buttonStyle }
              onClick={(e) => { nextPage(...typeAndOrder, 10, e.target.textContent , extraFilters); }}>
              {i + 1}
            </PaginationLink>
          </PaginationItem>
        );
      }
    }


    if (stateStatus.totalPages < 2) {
      return null;
    } else if (initialPages.length > 0 && stateStatus.totalPages < 6) {
      return <Pagination aria-label="Page navigation"> {initialPages} </Pagination>;
    }


    return (
      <Pagination aria-label="Page navigation">

        {stateStatus.currentPage !== 1 && stateStatus.currentPage > 3 && <PaginationItem>
          <PaginationLink style={buttonStyle} onClick={(e) => { nextPage(...typeAndOrder, 10, e.target.textContent ,extraFilters) }}>
            1
          </PaginationLink>
        </PaginationItem>}

        {/*button separator*/}
        {stateStatus.currentPage !== 1 && stateStatus.currentPage > 3 &&
          <PaginationItem>
            <PaginationLink style={buttonStyle} >
              ...
              </PaginationLink>
          </PaginationItem>}

        {stateStatus.currentPage > 2 && <PaginationItem>
          <PaginationLink style={buttonStyle} onClick={(e) => { nextPage(...typeAndOrder, 10, e.target.textContent, extraFilters) }}>
            {stateStatus.prevPage - 1}
          </PaginationLink>
        </PaginationItem>}

        {stateStatus.currentPage > 1 && <PaginationItem>
          <PaginationLink style={buttonStyle} onClick={(e) => { nextPage(...typeAndOrder, 10, e.target.textContent, extraFilters) }}>
            {stateStatus.prevPage}
          </PaginationLink>
        </PaginationItem>}


        {/* current page */}
        {stateStatus.currentPage !== stateStatus.totalPages && <PaginationItem>
          <PaginationLink  style={activeStyle} onClick={(e) => { nextPage(...typeAndOrder, 10, e.target.textContent, extraFilters) }}>
            {stateStatus.currentPage}
          </PaginationLink>
        </PaginationItem>}

        {/*next page */}
        {stateStatus.currentPage + 1 < stateStatus.totalPages && <PaginationItem>
          <PaginationLink style={buttonStyle} onClick={(e) => { nextPage(...typeAndOrder, 10, e.target.textContent, extraFilters) }}>
            {stateStatus.nextPage}
          </PaginationLink>
        </PaginationItem>}

        {/* page subsequent to next page */}

        {stateStatus.currentPage + 2 < stateStatus.totalPages && <PaginationItem>
          <PaginationLink style={buttonStyle} onClick={(e) => { nextPage(...typeAndOrder, 10, e.target.textContent, extraFilters) }}>
            {stateStatus.nextPage + 1}
          </PaginationLink>
        </PaginationItem>}



        {/*button separator*/}
        <PaginationItem>
          <PaginationLink style={buttonStyle} >
            ...
          </PaginationLink>
        </PaginationItem>


        {/*total pages*/ stateStatus.totalPages > 4 && <PaginationItem>
          <PaginationLink  style={buttonStyle} onClick={(e) => { nextPage(...typeAndOrder, 10, e.target.textContent , extraFilters) }}>
            {stateStatus.totalPages}
          </PaginationLink>
        </PaginationItem>}

        <PaginationItem disabled={stateStatus.currentPage === stateStatus.totalPages}>
          <PaginationLink  style={buttonStyle} next onClick={() => { nextPage(...typeAndOrder, 10, stateStatus.currentPage + 1, extraFilters) }} />
        </PaginationItem>
      </Pagination>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Pagination.js